import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#0F0F0F",
      "fill-rule": "evenodd",
      d: "M12 10.94 5.46 4.398l-1.061 1.06L10.939 12 4.4 18.54l1.06 1.062L12 13.06l6.54 6.54 1.061-1.06-6.54-6.54 6.54-6.542-1.06-1.06z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }